module.exports = __webpack_public_path__ + "assets/sales-recruiters-phoenix-6.c309efd8.png";